// Revise ▸ Comments: every open comment and suggestion in the manuscript, in reading order.
export { CommentsPage as component } from '../../views/CommentsPage.tsx';
export const room = 'revise';
export const page = 'comments';
export const title = 'Comments';
export const help = 'margin-comments';
